import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly endpointGetAuthLogin = 'auth/saml';

  constructor(private readonly httpService: HttpService) { }

  isAuthenticated(): Promise <boolean> {
    return new Promise((resolve) => {
      const user = this.getAuthorizationToken();
      if (user) {
        resolve(true);
      }
      resolve(false);
    });
  }

  saveLocalStorage(state): Promise<any> {
    return new Promise( (resolve) => {
      localStorage.setItem('name', state.user.name)
      localStorage.setItem('authToken', state.token)
      localStorage.setItem('email', state.user.email)
      //localStorage.setItem('authToken', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOiI2ODFiYWM3NWQyMTQ0ZTQ1MzBmODQ0MzUiLCJyb2xlIjoidXNlciJ9LCJpYXQiOjE3NDczMjU1NDB9.lAHvopOANwtr_TkFflRlw3oAcbE2jrqGM260caHBIEo')
      // localStorage.setItem('login', state);
      // localStorage.setItem('name', 'ENACOM');
      const role = state.user?.role || this.extractRoleFromToken(state.token);
      if (role) {
        localStorage.setItem('role', role);
      }
      resolve(true);
    });
  }

  private extractRoleFromToken(token: string): string {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload?.sub?.role || '';
    } catch {
      return '';
    }
  }

  removeLocalStorage(): Promise<any> {
    return new Promise<any>((resolve) => {
      const favoriteProjects = localStorage.getItem('favoriteProjects');

      sessionStorage.clear();
      localStorage.clear();

      if (favoriteProjects) {
        localStorage.setItem('favoriteProjects', favoriteProjects);
      }

      resolve(true);
    });
  }

  getAuthorizationToken() {
    //localStorage.setItem('authToken', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOiI2ODFiYWM3NWQyMTQ0ZTQ1MzBmODQ0MzUiLCJyb2xlIjoidXNlciJ9LCJpYXQiOjE3NTQzMjQ4NjcsImV4cCI6MTc1NDQxMTI2N30.AdcOG-7beRosioEvyBXOEgPBFRk6Gd_w-jfWlOLq9y4')
    //return true;
    return localStorage.getItem('authToken');
  }

  getAuthUser(): Observable<any> {
    return this.httpService.genericGet(this.endpointGetAuthLogin, null)
      .pipe((res) => {
        return res;
      });
  }

}
